// Allowlist of query parameters that may pre-fill Marketo form fields (parameter -> Marketo field)
const QUERY_PARAMETER_TO_MARKETO_FIELD: Record<string, string> = {
	email: 'Email',
}

export const getMarketoPrefillValues = (search: string): Record<string, string> => {
	const searchParameters = new URLSearchParams(search)
	const prefillValues: Record<string, string> = {}

	for (const [parameterName, marketoFieldName] of Object.entries(
		QUERY_PARAMETER_TO_MARKETO_FIELD,
	)) {
		const value = searchParameters.get(parameterName)
		if (value) {
			prefillValues[marketoFieldName] = value
		}
	}

	return prefillValues
}
